(ns pfo.widget.autocomplete
  (:require [pfo.util :as util]
            [applied-science.js-interop :as j]))

(defn primary-theme [theme]
  (let [theme (js->clj theme :keywordize-keys true)]

    (clj->js (merge theme {;CSS :key value pairs for theme
                           :colors (merge (:colors theme) {:primary "#709AC4" #_"#E9F1F4"
                                                           :primary25 "#97b6d3"#_"#E9F1F48c"
                                                           :primary50 "#E9F1F4d1"
                                                           :neutral80 "inherit"})}))))

(def react-select-styles
  "@see https://react-select.com/styles"
  {:primary {:styles {:control (fn [provided _]
                                 (j/assoc! provided
                                   :boxShadow "0px 0px 17px 0 #d6d9d9"
                                   :borderColor  "transparent"))
                      :option (fn [provided opts]
                               (let [{:keys [isFocused isSelected]} (util/to-clj opts)]
                                 (j/assoc! provided
                                  :color (cond
                                           isSelected "white"
                                           isFocused "#555"
                                           :else "inherit"))))}
             :theme primary-theme}


   :second {:styles {:control (fn [provided _]
                                (j/assoc! provided
                                  :boxShadow "0px 0px 17px 0 #d6d9d9"
                                  :borderColor  "#008080"))}
            :theme primary-theme}})

